import React from 'react';
import {Button} from 'react-bootstrap';

export default props => {
  const {isUpdating, initialize, selected, updateMatches, isMatching} = props;
  const handleClick = () => updateMatches(selected);
  const runPdf = (selected, data) => {
    console.log(selected)
    console.log(data)
  }
  return (
    <div className="controls">
      <Button bsStyle="info" disabled={isUpdating} onClick={initialize}>
        Refresh
      </Button>
      
      <Button bsStyle="primary" onClick={handleClick} disabled={isMatching}>
        { isMatching ? 'Running...' : 'Run Matching' }
      </Button>

      <form method="post" encType="multipart/form-data" action="/files">
        <label htmlFor="file">Upload a resume</label>
          <input type="file" name="file" />
        <label htmlFor="user">Input User ID (found in User Details)</label>
          <input name="user" />
          <input type="submit" className="button" />
      </form>

      <form method="post" action="/pdf">
        <label htmlFor="vacancy">Input Vacancy ID for PDF Processor (found in Vacancy Details)</label>
          <input name="vacancy" />
          <input type="submit" className="button" />
      </form>
        <Button bsStyle="primary" onClick={runPdf} disabled={isMatching}>
          Run PDF
        </Button>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/candidates/Controls.jsx